import styled from 'styled-components'
import COLORS from '@colors'

export const Option = styled.div`
  background-color: ${props => (props.active ? COLORS.gray45 : COLORS.white)};
  color: ${props => (props.active ? COLORS.white : COLORS.gray45)};
  cursor: pointer;
  padding: 5px;
`

export const Container = styled.div`
  background-color: ${COLORS.white};
  border-radius: 0 0 4px 4px;
  max-height: 50px;
  overflow-y: auto;
`
